if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.featured = this.dataset.featured;
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener("change", this.onVariantChange);
      this.other = Array.from(
        document.querySelectorAll("variant-selects"),
      ).filter((selector) => {
        return selector != this;
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (!this.featured) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
        } else if (fieldset.querySelectorAll("input").length) {
          this.options.push(fieldset.querySelector("input:checked").value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector(".form__label__value");
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === "false") {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll("fieldset"),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector("select")) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll("input").length) {
            fieldsets_array[i].querySelector(
              `input[value='${option}']`,
            ).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      if (!document.querySelector("product-slider")) {
        return;
      }

      document
        .querySelector("product-slider")
        .updateVariantImages(this.currentVariant.id);

      let productSlider = document.querySelector(
        ".thb-product-detail .product-images",
      ),
        thumbnails = document.querySelector(
          ".thb-product-detail #Product-Thumbnails",
        );

      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        productSlider,
        thumbnails,
      );
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      var hide_variants = productSlider.dataset.hideVariants == "true",
        flkty = Flickity.data(productSlider),
        images = productSlider.querySelectorAll(".product-images__slide");

      if (flkty && hide_variants) {
        [].forEach.call(images, function (el) {
          el.classList.remove("is-selected");
        });
        productSlider.querySelector(mediaId).classList.add("is-selected");
        productSlider.reInit();
        productSlider.selectCell(mediaId);

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          thumbnails.prepend(activeThumb);
        }
      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`,
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`,
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        // Sold out products can be left without a form by the Parfumdreams link.
        if (!input) return;
        input.value = this.currentVariant.id;
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper",
      );

      if (!pickUpAvailability) return;
      /*
       * The element comes back with the buy buttons when a sold out variant is
       * left behind, see `getSectionsToRender`. Its script tag does not run
       * again from that re-render, so the custom element stays unupgraded when
       * the page started out sold out.
       */
      if (typeof pickUpAvailability.fetchAvailability !== "function") return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      const sections = [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
      ];

      /*
       * With the "Perfumdreams Link" block a sold out variant replaces the buy
       * buttons with the store link instead of only disabling them, see
       * `main-product.liquid`, so both sides of that swap have to be re-rendered
       * when another variant is picked. The block always renders its wrapper,
       * which is what makes it detectable here. Without it the buy buttons never
       * change and are left alone, keeping the dynamic checkout button intact.
       */
      if (
        document.getElementById(`perfume-store-link-${this.dataset.section}`)
      ) {
        sections.push(
          `buy-buttons-${this.dataset.section}`,
          `perfume-store-link-${this.dataset.section}`,
          `sticky-cta-${this.dataset.section}`,
        );
      }

      return sections;
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`,
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + "--sticky");

            if (price) price.classList.remove("visibility-hidden");
            if (price_fixed) price_fixed.classList.remove("visibility-hidden");
          });
          this.toggleAddButton(
            !this.currentVariant.available,
            window.theme.variantStrings.soldOut,
          );

          /*
           * The buy buttons and the Parfumdreams link trade places in the swap
           * above, so the sticky bar has to re-anchor on whichever of the two is
           * now the call to action. It ignores the call when nothing moved.
           */
          document
            .querySelectorAll("product-add-to-cart-sticky")
            .forEach((sticky) => {
              if (typeof sticky.setupObservers === "function") {
                sticky.setupObservers();
              }
            });
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
      if (!productForm) return;

      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button",
      );

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text",
        );

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute("disabled", "disabled");
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute("disabled");
          submitButton.classList.remove("loading");
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button",
      );
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(
        `price-${this.dataset.section}--sticky`,
      );

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text",
        );
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add("sold-out");
      });
      if (price) price.classList.add("visibility-hidden");
      if (price_fixed) price_fixed.classList.add("visibility-hidden");
    }

    setDisabled() {
      if (this.isDisabledFeature != "true") {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data) {
        const selected_options = this.currentVariant.options.map(
          (value, index) => {
            return {
              value,
              index: `option${index + 1}`,
            };
          },
        );
        const available_options = this.createAvailableOptionsTree(
          variant_data,
          selected_options,
        );

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector("select")) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]",
                  ).disabled = true;
                } else {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]",
                  ).disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll("input").length) {
              fieldset.querySelectorAll("input").forEach((input, input_i) => {
                input.classList.toggle(
                  "is-disabled",
                  fieldset_options[input_i].isUnavailable,
                );
              });
            }
          }
        });
      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find(
              (option) => option.value === variant[index],
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true,
              };
              options[index].push(entry);
            }

            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce(
              (count, { value, index }) => {
                return variant[index] === value ? count + 1 : count;
              },
              0,
            );

            // Only enable an option if an available variant matches all but one current selected value
            if (
              countVariantOptionsThatMatchCurrent >=
              selected_options.length - 1
            ) {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }

            // Make sure if a variant is unavailable, disable currently selected option
            if (
              (!this.currentVariant || !this.currentVariant.available) &&
              selected_options.find(
                (option) =>
                  option.value === entry.value && index === option.index,
              )
            ) {
              entry.isUnavailable = true;
            }

            // First option is always enabled
            if (index === "option1") {
              entry.isUnavailable =
                entry.isUnavailable && variant.available
                  ? false
                  : entry.isUnavailable;
            }
          });

          return options;
        },
        {
          option1: [],
          option2: [],
          option3: [],
        },
      );
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked,
        ).value;
      });
    }
  }

  customElements.define("variant-radios", VariantRadios);
}
if (!customElements.get("product-slider")) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("change", this.setupProductGallery);
    }
    connectedCallback() {
      const product_container = this.closest(".thb-product-detail");
      const thumbnail_container = product_container.querySelector(
        ".product-thumbnail-container",
      );
      this.video_containers = this.querySelectorAll(
        ".product-single__media-external-video--play",
      );

      this.cloned_cells = this.cloneNode(true);
      this.hide_variants = this.dataset.hideVariants == "true";
      this.thumbnails =
        thumbnail_container.querySelectorAll(".product-thumbnail");
      this.prev_button = this.querySelector(".flickity-prev");
      this.next_button = this.querySelector(".flickity-next");
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: ".is-initial-selected",
        prevNextButtons: false,
        fade: false,
        cellSelector: ".product-images__slide",
      };

      if (this.hide_variants) {
        this.options.cellSelector =
          ".product-images__slide, .product-images__slide-item--variant.is-selected";
      }

      // Start Slider
      this.init();
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();
      this.updateVariantImages();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit() {
      this.flkty.destroy();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();
      this.updateVariantImages();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    updateVariantImages(currentVariantId = null) {
      if (currentVariantId == null) {
        if (this.hasAttribute("data-default-variant")) {
          currentVariantId = this.dataset.defaultVariant;
        } else {
          currentVariantId =
            document.querySelector("#product-form-installment input[name='id']")
              .value || null;
        }
        currentVariantId = currentVariantId.toString();
      }
      console.log("updateing varinat images iwth id", currentVariantId);
      this.querySelectorAll("[data-variant-id]").forEach((slide) => {
        if (slide.dataset.variantId !== currentVariantId) {
          this.flkty.remove(slide);
        }
      });

      document
        .querySelectorAll("#Product-Thumbnails .product-thumbnail")
        .forEach((thumbnail) => {
          if (
            thumbnail.hasAttribute("data-variant-id") &&
            thumbnail.dataset.variantId !== currentVariantId
          ) {
            thumbnail.setAttribute("data-show", false);
          }
        });

      document
        .querySelector(
          `#Product-Thumbnails .product-thumbnail[data-variant-id='${currentVariantId}']`,
        )
        ?.setAttribute("data-show", "true");

      if (
        this.querySelector(`[data-variant-id='${currentVariantId}']`) == null
      ) {
        for (let i = 0; i < this.cloned_cells.children.length; i++) {
          const childNode = this.cloned_cells.children[i];
          if (childNode.dataset.variantId == currentVariantId) {
            this.flkty.insert(childNode.cloneNode(true), 0);
          }
        }
      }

      if (this.hasAttribute("data-default-variant")) {
        const selectCell = this.querySelector(
          `[data-variant-id='${currentVariantId}']`,
        );
        const selectIndex = selectCell.dataset.useMediaIndex;
        if (selectIndex) {
          this.flkty.selectCell(`[data-thumbnail-index='${selectIndex}']`);
          console.log("Selecting " + selectIndex);
        }
      }
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        this.prev_button.addEventListener("click", (event) => {
          this.flkty.previous();
        });
        this.prev_button.addEventListener("keyup", (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        this.next_button.addEventListener("click", (event) => {
          this.flkty.next();
        });
        this.next_button.addEventListener("keyup", (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container
          .querySelector("button")
          .addEventListener("click", function () {
            container.setAttribute("hidden", "");
          });
      });
      this.flkty.on("settle", function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on("change", (index) => {
        let previous_slide = this.flkty.cells[_this.selectedIndex].element;
        let previous_media = previous_slide.querySelector(
          ".product-single__media",
        );
        let slide = this.flkty.cells[index].element;
        let media = slide.querySelector(".product-single__media");
        let active_thumb = this.thumbnails[index];

        if (media.classList.contains("product-single__media-native-video")) {
          media.querySelector("video").play();
        }

        this.thumbnails.forEach((item, i) => {
          item.classList.remove("is-initial-selected");
        });
        active_thumb.classList.add("is-initial-selected");
        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;

          // Detect if thumbnails are horizontal (bottom) on mobile only (desktop remains vertical)
          const galleryContainer = this.closest(".product-gallery-container");
          const isMobile =
            typeof window !== "undefined" &&
            window.matchMedia("(max-width: 767px)").matches;
          const isHorizontal =
            isMobile &&
            galleryContainer &&
            galleryContainer.classList.contains("thumbnails-mobile-bottom");

          if (isHorizontal) {
            // Horizontal scroll for thumbnails-bottom
            active_thumb.parentElement.scrollTo({
              left:
                active_thumb.offsetLeft -
                windowHalfWidth +
                active_thumb.clientWidth / 2,
              top: 0,
              behavior: "smooth",
            });
          } else {
            // Vertical scroll for thumbnails-left
            active_thumb.parentElement.scrollTo({
              left: 0,
              top:
                active_thumb.offsetTop -
                windowHalfHeight +
                active_thumb.clientHeight / 2,
              behavior: "smooth",
            });
          }
        });
        // Stop previous video
        if (
          previous_media.classList.contains(
            "product-single__media-external-video",
          )
        ) {
          if (previous_media.dataset.provider === "youtube") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: "",
              }),
              "*",
            );
          } else if (previous_media.dataset.provider === "vimeo") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                method: "pause",
              }),
              "*",
            );
          }
          previous_media
            .querySelector(".product-single__media-external-video--play")
            .removeAttribute("hidden");
        } else if (
          previous_media.classList.contains(
            "product-single__media-native-video",
          )
        ) {
          previous_media.querySelector("video").pause();
        }
      });

      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener("click", () => {
          this.thumbnailClick(thumbnail, index);
        });
      });
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        //el.classList.remove("is-initial-selected");
      });
      //thumbnail.classList.add("is-initial-selected");
      this.flkty.selectCell(`[data-thumbnail-index='${index}']`);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(
        this.querySelectorAll(
          ".product-images__slide .product-single__media-image, .product-images__slide-item--variant.is-selected .product-single__media-image",
        ),
      );
      return this.activeImages.map((item) => {
        let index = [].indexOf.call(
          item.parentNode.parentNode.children,
          item.parentNode,
        );

        let activelink = item.querySelector(".product-single__media-zoom");

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll(".product-single__media");
      this.pswpElement = document.querySelectorAll(".pswp")[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector(
            ".product-images__slide.is-selected",
          ),
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width,
          };
        },
      };

      this.links.forEach((link) => {
        if (link.classList.contains("product-single__media-native-video")) {
          return;
        }
        link.addEventListener("click", (e) => this.zoomClick(e, link));
      });
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== "undefined") {
        let pswp = new PhotoSwipe(
          this.pswpElement,
          PhotoSwipeUI_Default,
          this.items,
          this.pswpOptions,
        );
        pswp.listen("firstUpdate", function () {
          pswp.listen("parseVerticalMargin", function (item) {
            item.vGap = {
              top: 50,
              bottom: 50,
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define("product-slider", ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.sticky = this.dataset.sticky;
        this.form = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        if (this.form == null) {
          this.form = document.getElementById(this.dataset.productFormId);
        }
        this.form.querySelector("[name=id]").disabled = false;
        if (
          !this.sticky &&
          !this.form.hasAttribute("data-registered-submit-listener")
        ) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          this.form.setAttribute("data-registered-submit-listener", "true");
        }
        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButtons = document.querySelectorAll(
          ".single-add-to-cart-button",
        );

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains("loading")) return;
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
        });

        this.handleErrorMessage();

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };
        let formData = new FormData(this.form);

        formData.append(
          "sections",
          this.getSectionsToRender().map((section) => section.section),
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent("product:variant-error", {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              return;
            }

            this.renderContents(response);

            dispatchCustomEvent("cart:item-added", {
              product: response.hasOwnProperty("items")
                ? response.items[0]
                : response,
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            });
          });
      }

      getSectionsToRender() {
        return [
          {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );

          if (typeof CartDrawer !== "undefined") {
            new CartDrawer();
          }
          if (typeof Cart !== "undefined") {
            new Cart().renderContents(parsedState);
          }
        });

        let product_drawer = document.getElementById("Product-Drawer"),
          search_drawer = document.getElementById("Search-Drawer");

        if (search_drawer.classList.contains("active")) {
          search_drawer.classList.remove("active");
        }
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer.classList.remove("active");
          this.body.classList.remove("open-cc--product");
          if (document.getElementById("Cart-Drawer")) {
            this.body.classList.add("open-cc");
            document.getElementById("Cart-Drawer").classList.add("active");
          }
        } else if (document.getElementById("Cart-Drawer")) {
          this.body.classList.add("open-cc");
          document.getElementById("Cart-Drawer").classList.add("active");
          document.getElementById("Cart-Drawer").focus();
          dispatchCustomEvent("cart-drawer:open");
        }
      }
      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get("product-add-to-cart-sticky")) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setupObservers();
    }
    /*
     * The bar tracks the call to action of the page, which is the add to cart
     * form for most products but the Parfumdreams link while a variant is sold
     * out and the form is not rendered at all, see `main-product.liquid`. The
     * empty one of the two has no height and would never report an
     * intersection, hence the check. Products that end up without any call to
     * action leave the bar hidden, there would be nothing to put in it.
     */
    getAnchor() {
      const candidates = [
        document.getElementById(`product-form-${this.dataset.section}`),
        document.getElementById(`perfume-store-link-${this.dataset.section}`),
      ];
      return candidates.find((element) => element && element.offsetHeight > 0);
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              if (entry.target === footer) {
                if (entry.intersectionRatio > 0) {
                  _this.classList.remove("sticky--visible");
                } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                  _this.classList.add("sticky--visible");
                }
              }
              if (entry.target === form) {
                let boundingRect = form.getBoundingClientRect();

                if (
                  entry.intersectionRatio === 0 &&
                  window.scrollY > boundingRect.top + boundingRect.height
                ) {
                  _this.formPassed = true;
                  _this.classList.add("sticky--visible");
                } else if (entry.intersectionRatio === 1) {
                  _this.formPassed = false;
                  _this.classList.remove("sticky--visible");
                }
              }
            });
          },
          {
            threshold: [0, 1],
          },
        ),
        form = this.getAnchor(),
        footer = document.getElementById("footer");

      // Nothing to track, and re-observing the same anchor would only make the
      // bar flicker while the observer settles again.
      if (!form || !footer || form === this.anchor) return;

      if (this.observer) this.observer.disconnect();
      this.observer = observer;
      this.anchor = form;
      _this.formPassed = _this.formPassed || false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define("product-add-to-cart-sticky", ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get("side-panel-links")) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll("button");
      this.drawer = document.getElementById("Product-Information-Drawer");
      this.buttons = this.drawer.querySelector(".side-panel-content--tabs");
      this.panels = this.drawer
        .querySelector(".side-panel-content--inner")
        .querySelectorAll(".side-panel-content--tab-panel");
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() { }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.body.classList.add("open-cc");
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add("active");
        });
      });
    }
  }

  customElements.define("side-panel-links", ProductSidePanelLinks);
}

class ProductCardQuickAddVariants extends HTMLElement {
  constructor() {
    super();

    this.variantData = JSON.parse(
      this.querySelector("script[type='application/json']").textContent,
    );
    this.labels = this.querySelectorAll("label");
    const currentSelectedVariantId = parseInt(
      this.querySelector(".product-price-element[data-show='true']").dataset
        .variantId,
    );
    this.currentSelectedVariant = this.variantData.find(
      (variant) => variant.id === currentSelectedVariantId,
    );

    document
      .querySelector(
        `.product-card-quick-add-variants-open[data-product-id='${this.dataset.productId}']`,
      )
      .addEventListener("click", () => {
        this.toggle();
      });

    this.querySelector(".close-wrapper").addEventListener("click", () => {
      this.toggle();
    });

    this.labels.forEach((label) => {
      label.addEventListener("click", () => {
        const matchingInput = this.querySelector(
          "#" + label.getAttribute("for"),
        );
        matchingInput.checked = true;
        const optionValue = matchingInput.value;
        const matchingVariant = this.variantData.find(
          (variant) => variant.public_title === optionValue,
        );
        this.currentSelectedVariant = matchingVariant;

        this.querySelector(
          ".product-price-element[data-show='true']",
        ).setAttribute("data-show", false);
        this.querySelector(
          `.product-price-element[data-variant-id='${matchingVariant.id}']`,
        ).setAttribute("data-show", true);
        console.log(matchingVariant);

        this.querySelector(
          ".product-card-quick-add-variants-big-image[data-show='true']",
        ).setAttribute("data-show", false);
        this.querySelector(
          `.product-card-quick-add-variants-big-image[data-variant-id='${matchingVariant.id}']`,
        ).setAttribute("data-show", true);
      });
    });

    this.querySelector(".product-card--add-to-cart-button").addEventListener(
      "click",
      () => {
        console.log(this.currentSelectedVariant);
        customAddToCart(this.currentSelectedVariant.id, 1);
        this.toggle();
      },
    );
  }

  toggle() {
    const currentState = this.dataset.show === "true";
    this.setAttribute("data-show", !currentState);
  }
}

customElements.define(
  "product-card-quick-add-variants",
  ProductCardQuickAddVariants,
);

if (!customElements.get("pdp-tabs")) {
  class PdpTabs extends HTMLElement {
    constructor() {
      super();
      this.bars = this.querySelectorAll(".pdp-tabs__bar");
      this.tabs = this.querySelectorAll(".pdp-tabs__tab");
      this.bars.forEach((bar, index) => {
        bar.addEventListener("click", () => {
          this.closeAll();
          this.setActive(bar.dataset.tabType);
        });
      });

      if (
        this.querySelector("[data-tab-type='wirksamkeit']") &&
        document.querySelector("[data-pdp-tab-connection='wirksamkeit']") ==
        null
      ) {
        this.querySelector("[data-tab-type='wirksamkeit']").style.display =
          "none";
      }
    }

    closeAll() {
      this.bars.forEach((b) => b.setAttribute("data-active", "false"));
      this.tabs.forEach((t) => t.setAttribute("data-active", "false"));
    }

    setActive(handle) {
      const newActiveBar = Array.from(this.bars).find(
        (bar) => bar.dataset.tabType === handle,
      );
      const newActiveTab = Array.from(this.tabs).find(
        (tab) => tab.dataset.tabType === handle,
      );

      newActiveBar.setAttribute("data-active", "true");
      if (window.innerWidth < 1000) {
        newActiveBar.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      }
      newActiveTab.setAttribute("data-active", "true");
    }
  }
  customElements.define("pdp-tabs", PdpTabs);
}

if (!customElements.get("collapsible-tab")) {
  class CollapsibleTab extends HTMLElement {
    constructor() {
      super();
      this.textAll = this.querySelectorAll(".collapsible-tab__button-txt");
      this.content = this.querySelector(".collapsible-tab__content");

      this.addEventListener("click", () => {
        this.toggleText();
        this.toggleContent();
      });
    }

    toggleText() {
      this.textAll.forEach((txt) => {
        const isActive = txt.getAttribute("data-active") === "true";
        txt.setAttribute("data-active", isActive ? "false" : "true");
      });
    }

    toggleContent() {
      const contentIsActive =
        this.content.getAttribute("data-active") === "true";
      this.content.setAttribute(
        "data-active",
        contentIsActive ? "false" : "true",
      );
    }
  }

  customElements.define("collapsible-tab", CollapsibleTab);
}

if (!customElements.get("select-subscription")) {
  class SelectSubscription extends HTMLElement {
    constructor() {
      super();

      this.sellingPlanInputs = document.querySelectorAll(
        "input[name='selling_plan']",
      );
      this.form = this.querySelector("form");
    }

    connectedCallback() {
      this.form.addEventListener("change", () => {
        const formData = new FormData(this.form);
        let newSellingPlanValue = null;
        const purchaseOption = formData.get("Select-Purchase-Option");
        if (purchaseOption === "true") {
          newSellingPlanValue = formData.get("selling-plan");
        }
        this.sellingPlanInputs.forEach((sellingPlanInput) => {
          sellingPlanInput.value = newSellingPlanValue;
        });
      });
    }
  }

  customElements.define("select-subscription", SelectSubscription);

  class BackInStockModal extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector(".back-in-stock-modal__overlay");
      this.closeButton = this.querySelector(".back-in-stock-modal__close");
      this.form = this.querySelector(".back-in-stock-modal__form");
      this.submitButton = this.querySelector(".back-in-stock-modal__submit");
      this.submitText = this.querySelector(".back-in-stock-modal__submit-text");
      this.submitLoading = this.querySelector(
        ".back-in-stock-modal__submit-loading",
      );
      this.successView = this.querySelector(".back-in-stock-modal__success");
      this.errorView = this.querySelector(".back-in-stock-modal__error");
      this.errorMessage = this.querySelector(
        ".back-in-stock-modal__error-message",
      );
    }

    connectedCallback() {
      this.setupEventListeners();
    }

    setupEventListeners() {
      // Close modal when clicking overlay
      this.overlay.addEventListener("click", (e) => {
        if (e.target === this.overlay) {
          this.close();
        }
      });

      // Close modal when clicking close button
      this.closeButton.addEventListener("click", () => {
        this.close();
      });

      // Close modal with Escape key
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.classList.contains("is-open")) {
          this.close();
        }
      });

      // Handle form submission
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.handleSubmit();
      });
    }

    open() {
      // Check if URL Params include variantId
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("variant")) {
        const variantId = urlParams.get("variant");
        this.form.setAttribute("data-variant-id", variantId);
      } else {
        this.form.setAttribute(
          "data-variant-id",
          this.dataset.defaultVariantId,
        );
      }
      this.classList.add("is-open");
      document.body.style.overflow = "hidden";

      // Focus on email input
      const emailInput = this.querySelector(".back-in-stock-modal__input");
      setTimeout(() => emailInput.focus(), 100);
    }

    close() {
      this.classList.remove("is-open");
      document.body.style.overflow = "";
      this.resetForm();
    }

    async handleSubmit() {
      const formData = new FormData(this.form);
      const email = formData.get("email");
      const consent = formData.get("consent");
      const productId = this.form.getAttribute("data-product-id");
      const variantId = this.form.getAttribute("data-variant-id");

      // Basic validation
      if (!email || !email.includes("@")) {
        this.showError("Bitte geben Sie eine gültige E-Mail-Adresse ein.");
        return;
      }

      if (!variantId) {
        this.showError("Bitte wählen Sie eine Produktvariante aus.");
        return;
      }

      this.setLoading(true);
      this.hideError();

      try {
        // Use Klaviyo integration for back-in-stock subscription
        await this.pushKlaviyoBackInStock(variantId, email);
        this.showSuccess();
      } catch (error) {
        console.error("Back in stock subscription error:", error);
        // Show specific error message if available, otherwise use generic message
        const errorMessage =
          error.message ||
          "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
        this.showError(errorMessage);
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(isLoading) {
      this.submitButton.disabled = isLoading;
      if (isLoading) {
        this.submitText.style.display = "none";
        this.submitLoading.style.display = "block";
      } else {
        this.submitText.style.display = "block";
        this.submitLoading.style.display = "none";
      }
    }

    showSuccess() {
      this.form.style.display = "none";
      this.errorView.style.display = "none";
      this.successView.style.display = "block";

      // Auto close after 3 seconds
      setTimeout(() => {
        this.close();
      }, 3000);
    }

    showError(message) {
      this.errorMessage.textContent = message;
      this.errorView.style.display = "block";
    }

    hideError() {
      this.errorView.style.display = "none";
    }

    resetForm() {
      this.form.reset();
      this.form.style.display = "block";
      this.successView.style.display = "none";
      this.errorView.style.display = "none";
      this.setLoading(false);
    }

    async pushKlaviyoBackInStock(variantId, email) {
      try {
        const payload = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: "$shopify:::$default:::" + variantId,
                },
              },
            },
          },
        };

        var requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-06-15",
          },
          body: JSON.stringify(payload),
        };

        const urlParams = new URLSearchParams();
        urlParams.set("company_id", this.dataset.klaviyoCompanyId);

        const fetchRes = await fetch(
          "https://a.klaviyo.com/client/back-in-stock-subscriptions?" +
          urlParams.toString(),
          requestOptions,
        );

        if (!fetchRes.ok) {
          const errorText = await fetchRes.text();
          console.error("Klaviyo API error:", fetchRes.status, errorText);
          throw new Error(
            "Beim Eintragen ist etwas schief gelaufen. Bitte prüfe es später erneut",
          );
        }

        return true;
      } catch (error) {
        console.error("Klaviyo back-in-stock subscription error:", error);
        throw error;
      }
    }
  }

  customElements.define("back-in-stock-modal", BackInStockModal);

  // Utility function to open back-in-stock modal
  window.openBackInStockModal = function () {
    const modal = document.querySelector("back-in-stock-modal");
    modal.open();
  };
}
